import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a5dd18e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework" }
const _hoisted_2 = { class: "d-flex flex-column gap-7 gap-lg-10 w-100 min-w-lg-400px w-lg-400px mb-7 me-lg-10" }
const _hoisted_3 = { class: "card card-xl-stretch" }
const _hoisted_4 = { class: "card-header align-items-center border-0 pt-5" }
const _hoisted_5 = { class: "d-flex align-items-start flex-column m-0" }
const _hoisted_6 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_7 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_8 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true",
  id: "kt_menu_63995de553982"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bold" }, "Filter Options")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }),
  /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Status:"),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("select", {
          class: "form-select form-select-solid select2-hidden-accessible",
          "data-kt-select2": "true",
          "data-placeholder": "Select option",
          "data-dropdown-parent": "#kt_menu_63995de553982",
          "data-allow-clear": "true",
          "data-select2-id": "select2-data-10-k5y5",
          tabindex: "-1",
          "aria-hidden": "true",
          "data-kt-initialized": "1"
        }, [
          /*#__PURE__*/_createElementVNode("option", { "data-select2-id": "select2-data-12-fr4v" }),
          /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Approved"),
          /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Pending"),
          /*#__PURE__*/_createElementVNode("option", { value: "2" }, "In Process"),
          /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Rejected")
        ]),
        /*#__PURE__*/_createElementVNode("span", {
          class: "select2 select2-container select2-container--bootstrap5",
          dir: "ltr",
          "data-select2-id": "select2-data-11-17uc",
          style: {"width":"100%"}
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "selection" }, [
            /*#__PURE__*/_createElementVNode("span", {
              class: "select2-selection select2-selection--single form-select form-select-solid",
              role: "combobox",
              "aria-haspopup": "true",
              "aria-expanded": "false",
              tabindex: "0",
              "aria-disabled": "false",
              "aria-labelledby": "select2-d78w-container",
              "aria-controls": "select2-d78w-container"
            }, [
              /*#__PURE__*/_createElementVNode("span", {
                class: "select2-selection__rendered",
                id: "select2-d78w-container",
                role: "textbox",
                "aria-readonly": "true",
                title: "Select option"
              }, [
                /*#__PURE__*/_createElementVNode("span", { class: "select2-selection__placeholder" }, "Select option")
              ]),
              /*#__PURE__*/_createElementVNode("span", {
                class: "select2-selection__arrow",
                role: "presentation"
              }, [
                /*#__PURE__*/_createElementVNode("b", { role: "presentation" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("span", {
            class: "dropdown-wrapper",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Member Type:"),
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
        /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }, [
          /*#__PURE__*/_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "1"
          }),
          /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Author")
        ]),
        /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
          /*#__PURE__*/_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "2",
            checked: "checked"
          }),
          /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Customer")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold" }, "Notifications:"),
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          value: "",
          name: "notifications",
          checked: "checked"
        }),
        /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Enabled")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "reset",
        class: "btn btn-sm btn-light btn-active-light-primary me-2",
        "data-kt-menu-dismiss": "true"
      }, " Reset "),
      /*#__PURE__*/_createElementVNode("button", {
        type: "submit",
        class: "btn btn-sm btn-primary",
        "data-kt-menu-dismiss": "true"
      }, " Apply ")
    ])
  ])
], -1))
const _hoisted_11 = { class: "card-body pt-5" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "d-flex align-items-center mb-7" }
const _hoisted_15 = { class: "symbol symbol-50px me-4" }
const _hoisted_16 = { class: "symbol-label bg-light-info" }
const _hoisted_17 = { class: "svg-icon svg-icon-2x svg-icon-info" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "fw-bolder" }
const _hoisted_20 = { class: "fs-7 text-gray-400" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "d-flex align-items-center mb-7" }
const _hoisted_23 = { class: "symbol symbol-50px me-4" }
const _hoisted_24 = { class: "symbol-label bg-light-success" }
const _hoisted_25 = { class: "svg-icon svg-icon-2x svg-icon-success" }
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = { class: "fw-bolder" }
const _hoisted_28 = { class: "fs-7 text-gray-400" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "d-flex align-items-center mb-7" }
const _hoisted_31 = { class: "symbol symbol-50px me-4" }
const _hoisted_32 = { class: "symbol-label bg-light-danger" }
const _hoisted_33 = { class: "svg-icon svg-icon-2x svg-icon-danger" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "fw-bolder" }
const _hoisted_36 = { class: "fs-7 text-gray-400" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "d-flex align-items-center mb-7" }
const _hoisted_39 = { class: "symbol symbol-50px me-4" }
const _hoisted_40 = { class: "symbol-label bg-light-warning" }
const _hoisted_41 = { class: "svg-icon svg-icon-2x svg-icon-warning" }
const _hoisted_42 = { class: "d-flex flex-column" }
const _hoisted_43 = { class: "fw-bolder" }
const _hoisted_44 = { class: "fs-7 text-gray-400" }
const _hoisted_45 = { class: "fs-6 d-flex flex-column gap-5" }
const _hoisted_46 = { class: "fs-6" }
const _hoisted_47 = { class: "text-gray-500" }
const _hoisted_48 = { class: "fs-6" }
const _hoisted_49 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_50 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_51 = { class: "fs-6" }
const _hoisted_52 = { class: "text-gray-500" }
const _hoisted_53 = { class: "text-gray-500" }
const _hoisted_54 = { class: "text-gray-500" }
const _hoisted_55 = {
  id: "kt_docs_card_details_items",
  class: "collapse"
}
const _hoisted_56 = { class: "d-flex flex-column gap-5" }
const _hoisted_57 = { class: "fs-6" }
const _hoisted_58 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_59 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_60 = { class: "fs-6" }
const _hoisted_61 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_62 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_63 = { class: "fs-6" }
const _hoisted_64 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_65 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_66 = { class: "fs-6" }
const _hoisted_67 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_68 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_69 = { class: "fs-6" }
const _hoisted_70 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_71 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_72 = { class: "fs-6" }
const _hoisted_73 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_74 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_75 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_76 = {
  class: "toggle collapsible collapsed position-relative d-flex align-items-center text-primary fs-7 fw-bold cursor-pointer",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_details_items"
}
const _hoisted_77 = { class: "toggle-off" }
const _hoisted_78 = { class: "toggle-on" }
const _hoisted_79 = { class: "rotate-180" }
const _hoisted_80 = { class: "svg-icon svg-icon-3 svg-icon-primary" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute" }, null, -1))
const _hoisted_82 = {
  key: 0,
  class: "card card-xl-stretch"
}
const _hoisted_83 = { class: "card-header align-items-center border-0 pt-5" }
const _hoisted_84 = { class: "d-flex align-items-start flex-column m-0" }
const _hoisted_85 = { class: "card-body pt-5" }
const _hoisted_86 = { class: "d-flex flex-column gap-4 fw-bold" }
const _hoisted_87 = { class: "d-flex align-items-center" }
const _hoisted_88 = { class: "symbol symbol-50px symbol-circle overflow-hidden me-sm-2" }
const _hoisted_89 = { class: "symbol-label bg-transparent" }
const _hoisted_90 = { class: "svg-icon" }
const _hoisted_91 = { class: "flex-fill" }
const _hoisted_92 = { class: "d-flex justify-content-between fs-7 text-gray-400 mb-1" }
const _hoisted_93 = { class: "d-flex justify-content-between" }
const _hoisted_94 = { class: "d-flex align-items-center" }
const _hoisted_95 = { class: "symbol symbol-50px symbol-circle overflow-hidden me-sm-2" }
const _hoisted_96 = { class: "symbol-label bg-transparent" }
const _hoisted_97 = { class: "svg-icon" }
const _hoisted_98 = { class: "flex-fill" }
const _hoisted_99 = { class: "d-flex justify-content-between fs-7 text-gray-400 mb-1" }
const _hoisted_100 = { class: "d-flex justify-content-between" }
const _hoisted_101 = { class: "card card-xl-stretch" }
const _hoisted_102 = { class: "card-header align-items-center border-0 pt-5" }
const _hoisted_103 = { class: "d-flex align-items-start flex-column m-0" }
const _hoisted_104 = { class: "fs-7 text-gray-400" }
const _hoisted_105 = { class: "card-toolbar" }
const _hoisted_106 = { class: "card-body pt-5" }
const _hoisted_107 = { class: "d-flex flex-column gap-2 overflow-auto max-upload-height" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = { class: "symbol-label" }
const _hoisted_110 = { class: "flex-1 mx-2" }
const _hoisted_111 = { class: "fs-7 text-gray-400" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "svg-icon svg-icon-3" }
const _hoisted_114 = { class: "d-flex flex-column flex-row-fluid gap-7 gap-lg-10" }
const _hoisted_115 = {
  class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-n2",
  role: "tablist"
}
const _hoisted_116 = { class: "nav-item" }
const _hoisted_117 = { class: "nav-item" }
const _hoisted_118 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_119 = { class: "d-flex flex-column gap-7 gap-lg-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_upload_list = _resolveComponent("el-upload-list")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createElementVNode("span", null, "#" + _toDisplayString(_ctx.formData.qc_number), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t("inspection.needSkusInspcetion", [
                  _ctx.formData.relation_shipment.demand_quantity,
                ])), 1)
          ]),
          (0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                  ])
                ]),
                _hoisted_10
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art007.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formData.relation_shipment.demand_quantity), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t("inspection.demand")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm002.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formData.relation_shipment.passed_quantity), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.t("inspection.pass")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.formData.relation_shipment.failed_quantity), 1),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.t("inspection.fail")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm012.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formData.relation_shipment.missing_quantity), 1),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.t("inspection.missingQty")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.t("common.status")), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge text-uppercase", _ctx.getInspectionStatusMap(_ctx.formData.inspection_status)])
                  }, _toDisplayString(_ctx.formData.__show.inspection_status), 3)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.t("warehouse.warehouse")), 1),
                (_ctx.formData.warehouse_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.formData.warehouse_name), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.t("common.undefined")), 1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_51, _toDisplayString(_ctx.t("inbound.consigner")), 1),
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formData.relation_shipment.relation_delivery_from_location
                      .name), 1),
                _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.formData.relation_shipment.relation_delivery_from_location
                      .street), 1),
                _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.formData.relation_shipment.relation_delivery_from_location
                      .zip_code +
                    " " +
                    _ctx.formData.relation_shipment.relation_delivery_from_location
                      .location_str), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_57, _toDisplayString(_ctx.t("inspection.merchantRequestNo")), 1),
                    (_ctx.formData.merchant_request_number.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.CommonArrayToString(_ctx.formData.merchant_request_number)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_60, _toDisplayString(_ctx.t("order.merchantOrderNo")), 1),
                    (_ctx.formData.merchant_order_number.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.CommonArrayToString(_ctx.formData.merchant_order_number)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.t("shipments.trackingNo")), 1),
                    (_ctx.formData.relation_shipment.tracking_no)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.formData.relation_shipment.tracking_no), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_66, _toDisplayString(_ctx.t("inspection.receivedDate")), 1),
                    (_ctx.formData.received_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.customFormatDateTime(_ctx.formData.received_date)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_69, _toDisplayString(_ctx.t("inspection.inspectionDate")), 1),
                    (_ctx.formData.inspection_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.customFormatDateTime(_ctx.formData.inspection_date)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_72, _toDisplayString(_ctx.t("inspection.inspectedDate")), 1),
                    (_ctx.formData.inspected_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.customFormatDateTime(_ctx.formData.inspected_date)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.t("common.undefined")), 1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.t("inspection.showMore")), 1),
                  _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.t("inspection.closeMore")), 1),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("span", _hoisted_80, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ]),
                  _hoisted_81
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.options.inspectionDetail]
      ]),
      (_ctx.formData.inspection_date)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("h3", _hoisted_84, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspectionManager")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("span", _hoisted_89, [
                      _createElementVNode("span", _hoisted_90, [
                        _createVNode(_component_inline_svg_icon, {
                          class: "w-50px h-50px",
                          src: "media/icons/duotune/communication/com006.svg"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.t("inspection.firstInspection")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.t("common.date")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.first_inspection.name), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.customFormatDateTime(_ctx.formData.first_inspection.date)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("span", _hoisted_96, [
                      _createElementVNode("span", _hoisted_97, [
                        _createVNode(_component_inline_svg_icon, {
                          class: "w-50px h-50px",
                          src: "media/icons/duotune/communication/com006.svg"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.t("inspection.secondInspection")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.t("common.date")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.second_inspection.name), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.customFormatDateTime(_ctx.formData.second_inspection.date)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.options.inspectionDetail]
          ])
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_101, [
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspection.images")), 1),
            _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.t("inspection.imagesSubTitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createVNode(_component_el_upload_list, {
              accept: ".jpg,.jpeg,.png",
              "click-class": "btn-sm btn-light-primary",
              clickIcon: "media/icons/duotune/general/gen006.svg",
              clickToUpload: _ctx.t('inspection.uploadPhotos'),
              listType: "picture",
              fileId: "file_upload_record_id",
              name: "files",
              uploadUrl: _ctx.uploadUrl,
              isShowList: false,
              isShowRemoveAll: false,
              limit: _ctx.options.maxFiles,
              multiple: true,
              autoUpload: false,
              disabledClick: _ctx.options.uploading,
              onMultipleUploadFiles: _ctx.multipleUpload
            }, null, 8, ["clickToUpload", "uploadUrl", "limit", "disabledClick", "onMultipleUploadFiles"])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fileList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-items-center el-upload-list-custom py-2 border-gray-300 border-bottom-dashed",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "symbol symbol-50px overflow-hidden cursor-pointer",
                  onClick: ($event: any) => (_ctx.previewImages(index))
                }, [
                  _createElementVNode("span", _hoisted_109, [
                    _createVNode(_component_el_image, {
                      src: item.url + '?x-oss-process=image/resize,l_200',
                      fit: "contain"
                    }, null, 8, ["src"])
                  ])
                ], 8, _hoisted_108),
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.bytesToSize(item.size)), 1)
                ]),
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (
                    _ctx.formData.inspection_status !== _ctx.InspectionStatus.Inspected &&
                    _ctx.formData.inspection_status !== _ctx.InspectionStatus.Stocked
                  )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-icon btn-light-danger btn-sm",
                          onClick: ($event: any) => (_ctx.removeItem(item, index))
                        }, [
                          _createElementVNode("span", _hoisted_113, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr011.svg" })
                          ])
                        ], 8, _hoisted_112))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ])), [
          [_directive_loading, _ctx.options.uploading]
        ])
      ])), [
        [_directive_loading, _ctx.options.images]
      ])
    ]),
    _createElementVNode("div", _hoisted_114, [
      _createElementVNode("ul", _hoisted_115, [
        _createElementVNode("li", _hoisted_116, [
          _createVNode(_component_router_link, {
            to: 
              '/warehouse-management/inspection/' +
              _ctx.$route.params.id +
              '/overview'
            ,
            replace: "",
            class: "nav-link text-active-primary me-6",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("common.overview")), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_117, [
          _createVNode(_component_router_link, {
            to: 
              '/warehouse-management/inspection/' +
              _ctx.$route.params.id +
              '/inspections'
            ,
            replace: "",
            class: "nav-link text-active-primary me-6",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("inspection.inspections")), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_118, [
              _createVNode(_component_router_link, {
                to: 
              '/warehouse-management/inspection/' + _ctx.$route.params.id + '/logs'
            ,
                replace: "",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("common.logs")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_119, [
        _createVNode(_component_router_view, {
          loading: _ctx.loading,
          detailData: _ctx.formData,
          onGetFormData: _ctx.getFromInfo
        }, null, 8, ["loading", "detailData", "onGetFormData"])
      ])
    ])
  ]))
}